import { render, staticRenderFns } from "./printCommonReportTableList.vue?vue&type=template&id=db859028&scoped=true"
import script from "./printCommonReportTableList.vue?vue&type=script&lang=js"
export * from "./printCommonReportTableList.vue?vue&type=script&lang=js"
import style0 from "./printCommonReportTableList.vue?vue&type=style&index=0&id=db859028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db859028",
  null
  
)

export default component.exports